// src/hooks/useSessionTimeout.js — Item 27: Inactivity-based session timeout
import { useEffect, useRef, useCallback } from "react";

const WARN_MS   = 25 * 60 * 1000; // warn after 25 min
const LOGOUT_MS = 30 * 60 * 1000; // logout after 30 min

export function useSessionTimeout({ onWarn, onLogout, enabled = true }) {
  const warnRef   = useRef(null);
  const logoutRef = useRef(null);

  const reset = useCallback(() => {
    clearTimeout(warnRef.current);
    clearTimeout(logoutRef.current);
    if (!enabled) return;
    warnRef.current   = setTimeout(onWarn,   WARN_MS);
    logoutRef.current = setTimeout(onLogout, LOGOUT_MS);
  }, [onWarn, onLogout, enabled]);

  useEffect(() => {
    if (!enabled) return;
    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];
    events.forEach(e => window.addEventListener(e, reset, { passive: true }));
    reset();
    return () => {
      events.forEach(e => window.removeEventListener(e, reset));
      clearTimeout(warnRef.current);
      clearTimeout(logoutRef.current);
    };
  }, [enabled, reset]);
}
